var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSort32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.65 24a.824.824 0 01-.163-.017.745.745 0 01-.283-.13l-.003-.002a.747.747 0 01-.079-.068l-.002-.002-4.005-3.995a.75.75 0 01.975-1.135l.084.073 2.726 2.72V11.25a.75.75 0 011.493-.102l.007.102v10.192l2.72-2.718a.75.75 0 01.976-.072l.084.073a.75.75 0 01.072.976l-.072.084-3.988 3.983a.749.749 0 01-.543.232zM12.4 11.058l2.725 2.718.084.073a.75.75 0 00.975-1.135L12.19 8.73a.748.748 0 00-1.07-.01l-4 3.996-.072.084a.75.75 0 00.072.976l.084.073a.75.75 0 00.976-.072l2.72-2.718V21.25l.008.102a.75.75 0 001.493-.102V11.058z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSort32);
export default __webpack_public_path__ + "static/media/icon-sort-32.2154118f.svg";
export { ForwardRef as ReactComponent };